import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface interactionType {
  sidebarToggle: boolean;
  alertsToggle: boolean;
  modalToggle: boolean;
  alertContent: string;
  alertAction: any;
  userModalToggle: boolean;
  projectModalToggle: boolean;
  toastPopupToggle: boolean;
  checkListModalToggle: boolean;
  quotationListModalToggle: boolean;
  fieldCheckSearchListModalToggle: boolean; // note SmokingScully 2022-03-02 추가
  itemReviewListModalToggle: boolean; // note SmokingScully 2022-02-19 추가
  itemReviewModalToggle: boolean;
  toastPopupContents: string;
  severity: Color;
  checkListSwitch: number;
  evaluationToggle: boolean;
  helpToggle: boolean;
  auditPlanToggle: boolean;
  auditMembersToggle: boolean;
}
const initialState: interactionType = {
  sidebarToggle: false,
  alertsToggle: false,
  modalToggle: false,
  alertContent: "",
  alertAction: () => { },
  userModalToggle: false,
  projectModalToggle: false,
  toastPopupToggle: false,
  checkListModalToggle: false,
  quotationListModalToggle: false,
  fieldCheckSearchListModalToggle: false,
  itemReviewListModalToggle : false, // note SmokingScully 2022-02-19 추가
  itemReviewModalToggle: false,
  toastPopupContents: "",
  severity: "info",
  checkListSwitch: 0,
  evaluationToggle: false,
  helpToggle: false,
  auditPlanToggle: false,
  auditMembersToggle: false,
};

//note 추 후 alertAction 타입 지정요망

type alertActionType = {
  alertContent: string;
  alertAction: any;
};

type Color = "success" | "info" | "warning" | "error";
type ToastPopupType = {
  contents: string;
  severity: Color;
};

const interactionSlice = createSlice({
  name: "interaction",
  initialState,
  reducers: {
    sidebarToggleAction: (state) => {
      state.sidebarToggle = !state.sidebarToggle;
    },
    sidebarCloseAction: (state) => {
      state.sidebarToggle = false;
    },
    alertsConfirmAction: (
      state,
      { payload }: PayloadAction<Partial<alertActionType>>
    ) => {
      state.alertsToggle = true;
      state.alertContent = payload.alertContent!;
      state.alertAction = payload.alertAction!;
    },
    alertsCloseAction: (state) => {
      state.alertsToggle = false;
    },
    modalOpenAction: (state) => {
      state.modalToggle = true;
    },
    modalCloseAction: (state) => {
      state.modalToggle = false;
    },

    userModalOpenAction: (state) => {
      state.userModalToggle = true;
    },
    userModalCloseAction: (state) => {
      state.userModalToggle = false;
    },
    projectModalOpenAction: (state) => {
      state.projectModalToggle = true;
    },
    projectModalCloseAction: (state) => {
      state.projectModalToggle = false;
    },
    checkListOpenAction: (state) => {
      state.checkListModalToggle = true;
    },
    checkListCloseAction: (state) => {
      state.checkListModalToggle = false;
    },
    quotationListOpenAction: (state) => {
      state.quotationListModalToggle = true;
    },
    quotationListCloseAction: (state) => {
      state.quotationListModalToggle = false;
    },
    fieldCheckSearchListOpenAction: (state) => {
      state.fieldCheckSearchListModalToggle = true;
    },
    fieldCheckSearchListCloseAction: (state) => {
      state.fieldCheckSearchListModalToggle = false;
    },
    // note SmokingScully 2022-02-19 추가
    itemReviewListOpenAction: (state) => {
      state.itemReviewListModalToggle = true;
    },
    itemReviewListCloseAction: (state) => {
      state.itemReviewListModalToggle = false;
    },
    itemReviewOpenAction: (state) => {
      state.itemReviewModalToggle = true;
    },
    itemReviewCloseAction: (state) => {
      state.itemReviewModalToggle = false;
    },
    toastPopupOpenAction: (state, { payload }: PayloadAction<ToastPopupType>) => {
      state.toastPopupToggle = true;
      state.toastPopupContents = payload.contents;
      state.severity = payload.severity;
    },
    toastPopupCloseAction: (state) => {
      state.toastPopupToggle = false;
    },
    evaluationToggleAction: (state) => {
      state.evaluationToggle = !state.evaluationToggle;
    },
    evaluationToggleOffAction: (state) => {
      state.evaluationToggle = false;
    },
    helpToggleAction: (state) => {
      state.helpToggle = !state.helpToggle;
    },
    auditPlanOpenAction: (state) => {
      state.auditPlanToggle = true;
    },
    auditPlanCloseAction: (state) => {
      state.auditPlanToggle = false;
    },
    auditMembersOpenAction: (state) => {
      state.auditMembersToggle = true;
    },
    auditMembersCloseAction: (state) => {
      state.auditMembersToggle = false;
    },

    toastPopupContentsAction: (state, { payload }: PayloadAction<string>) => {
      state.toastPopupContents = payload;
    },
    checkListSwitchAction: (state, { payload }: PayloadAction<number>) => {
      state.checkListSwitch = payload;
    },
  },
});
export const {
  sidebarToggleAction,
  sidebarCloseAction,
  alertsConfirmAction,
  alertsCloseAction,
  modalOpenAction,
  modalCloseAction,
  userModalOpenAction,
  userModalCloseAction,
  projectModalOpenAction,
  projectModalCloseAction,
  checkListOpenAction,
  checkListCloseAction,
  quotationListOpenAction,
  quotationListCloseAction,
  fieldCheckSearchListOpenAction,
  fieldCheckSearchListCloseAction,
  itemReviewListOpenAction,
  itemReviewListCloseAction,
  itemReviewOpenAction,
  itemReviewCloseAction,
  toastPopupOpenAction,
  toastPopupCloseAction,
  toastPopupContentsAction,
  checkListSwitchAction,
  evaluationToggleAction,
  evaluationToggleOffAction,
  helpToggleAction,
  auditPlanOpenAction,
  auditPlanCloseAction,
  auditMembersOpenAction,
  auditMembersCloseAction,
} = interactionSlice.actions;

export default interactionSlice.reducer;
